var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6656 29.9994C16.6656 18.9999 16.6656 13.5002 20.0827 10.0831C23.4998 6.66602 28.9995 6.66602 39.999 6.66602C50.9983 6.66602 56.498 6.66602 59.9153 10.0831C63.3323 13.5002 63.3323 18.9999 63.3323 29.9994V49.9994C63.3323 60.9987 63.3323 66.4983 59.9153 69.9157C56.498 73.3327 50.9983 73.3327 39.999 73.3327C28.9995 73.3327 23.4998 73.3327 20.0827 69.9157C16.6656 66.4983 16.6656 60.9987 16.6656 49.9994V29.9994Z",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6656 63.334H43.3323",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.66602L30.2967 8.44608C30.9396 12.3036 31.2611 14.2324 32.584 15.4061C33.964 16.6305 35.9203 16.666 40 16.666C44.0797 16.666 46.036 16.6305 47.416 15.4061C48.739 14.2324 49.0603 12.3036 49.7033 8.44608L50 6.66602",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPhone);
export default __webpack_public_path__ + "static/media/smart-phone.79d1d4a20a1f431330c9205ec355e55e.svg";
export { ForwardRef as ReactComponent };